<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img10_2" src="images/img10_2.jpg"/></p>
<p class="caption">Making officers in just three months presented a challenge. A Regular officer lectures officer cadets. 7USa</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01j_AMERICAN_EXPEDITIONARY_FORCE.vue?67740b8d